import axios from 'axios';
import {apiRoot} from '@/config/config'


//读取物质列表
export async function getMaterials(params: any,token: string) {
  // return await fetch(`${apiRoot}/materials`, {
  //   method: 'GET',
  //   headers: {
  //     'Authorization': `Bearer ${token}`,
  //     'Content-Type': 'application/json',
  //   },
  // });

  return await axios({
    url: `${apiRoot}/materials`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//读取参数名称列表
export async function getParameters(params: any,token: string) {
  // return await fetch(`${apiRoot}/materials`, {
  //   method: 'GET',
  //   headers: {
  //     'Authorization': `Bearer ${token}`,
  //     'Content-Type': 'application/json',
  //   },
  // });

  return await axios({
    url: `${apiRoot}/parameters`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

